module.exports = __webpack_public_path__ + "media/application/images/svgs/play-3ae7c26aa059ae971f1a60f7017879e1.svg";